import { createSelector } from 'reselect'
import { RootState } from '../index'

export const currentUserSelector = createSelector(
  (state: RootState) => state.user.user,
  (user) => user,
)

export const authStateSelector = createSelector(
  (state: RootState) => state.user.isAuthenticated,
  (isAuthenticated) => isAuthenticated,
)

export const userOrganizationsSelector = createSelector(
  (state: RootState) => state.user.user?.organizations,
  (organizations) => organizations,
)

export const userDealershipsSelector = createSelector(
  (state: RootState) => state.user.user?.dealerships,
  (dealerships) => dealerships,
)

export const userConnectedVendorAccounts = createSelector(
  (state: RootState) => state.user.user?.vendors,
  (vendors) => vendors,
)
